function PicsumLinkGenerator(h, l) {
  return `https://picsum.photos/${h}/${l}`;
}

export default PicsumLinkGenerator;
